module.exports = __webpack_public_path__ + "static/vinyard1-9a68d07f638c64965bec29da3a6674f7.jpg";